import AllChoosed from './all-choosed'

export default {
    install: function(Vue) {
        Vue.component('AllChoosed', AllChoosed)
    }
}